module.exports = __webpack_public_path__ + "./kit/docs/img/icon-questions.e2d7ec2db5f6a4f00fcd193a87130016.svg";